export default __webpack_public_path__ + "static/media/gal2.30d8d818.jpeg";